import { render, staticRenderFns } from "./UserInfoItem.vue?vue&type=template&id=48d6b35c&scoped=true&"
import script from "./UserInfoItem.vue?vue&type=script&lang=js&"
export * from "./UserInfoItem.vue?vue&type=script&lang=js&"
import style0 from "./UserInfoItem.vue?vue&type=style&index=0&id=48d6b35c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d6b35c",
  null
  
)

export default component.exports